const e = { "logged-ticket-private": "{{name}} registrou isto", view: "Visualizar", "view-ticket": "Ver bilhete/ingresso", meeting: "Reunião", "shared-private": "{{name}} compartilhou isto", "logged-ticket-public": "{{name}} registrou isto", "shared-public": "{{name}} registrou isto", "crated-meeting-public": "{{name}} compartilhou uma reunião", "crated-meeting-private": "{{name}} criou uma reunião" }, i = { ticketing: "Emissão de bilhetes/ingressos", messaging: "Mensagens" }, t = {
  link: e,
  category: i
};
export {
  i as category,
  t as default,
  e as link
};
